function MenuAula7() {
  

    return (
      <>
        <nav>
            <ul>
              <li><a href="#Web-Components">Web Components</a></li>
              <li><a href="#Custom-Elements">Elementos Customizados</a></li>
              <li><a href="#Usando-Shadow-Dom">Usando Shadow Dom</a></li>
              <li><a href="#Template-Elements">Template Elements</a></li>
            </ul>
        </nav>
      </>
    );
  }
  
  export default MenuAula7;